module.exports = __webpack_public_path__ + "static/other/gameJigsawPuzzle5x5.5f0e0145.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameJigsawPuzzle5x5.json
// module id = 2461
// module chunks = 0